import template from './base-block.html';
import controller from './base-block.controller';
import './base-block.scss';

export default {
	template,
	bindings: {
		icon: '@',
		type: '@',
		tooltip: '@',

		invertDir: '<?',
		isOpen: '=?',
		isLoading: '<',
		preventToggling: '<',
		allowFullscreen: '<?',

		onAdd: '&?',
		onRefresh: '&?',

		onOpened: '&?',
		onClosed: '&?',
		onClick: '&?',
		onFullscreenChange: '&?',

		options: '<?',
	},
	transclude: {
		title: 'blockTitle',
		body: 'blockBody',
		actions: '?blockActions',
	},
	controller,
};
